<template>
  <a-modal
    title="配置管理"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :wrapClassName="uploading ? 'config-modal-uploading' : ''"
    @ok="handleOk"
    @cancel="handleCancel"
    ok-text="确定"
    cancel-text="取消">
    <a-form :form="form" layout="horizontal">
      <!-- 基本信息行 - 两列布局 -->
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="配置名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: '请输入配置名称' }] }]"
              placeholder="请输入配置名称" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="配置备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-input placeholder="请输入配置备注" v-decorator="['desc']" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 开机图片和开机动画 - 两列布局 -->
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="开机图片" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-radio-group v-decorator="['bootImageType', { initialValue: 0 }]">
              <a-radio :value="0">开机默认</a-radio>
              <a-radio :value="1">自定义</a-radio>
            </a-radio-group>

            <div v-if="form.getFieldValue('bootImageType') === 1" style="margin-top: 12px">
              <!-- 1080P 开机图片 -->
              <div>
                <div style="margin-bottom: 4px; font-size: 12px; color: #666">1080P(格式jpg，尺寸1920*1080，大小不超过10M)</div>
                <a-upload
                  name="file"
                  :before-upload="beforeUploadImage"
                  :show-upload-list="false"
                  accept=".jpg,.png"
                  list-type="picture-card">
                  <div v-if="!bootImageUploadUrl">
                    <a-icon type="plus" />
                    <div style="margin-top: 8px">上传</div>
                  </div>
                  <img v-else :src="bootImageUploadUrl.downloadUrl" style="width: 100%; height: 100%; object-fit: cover" />
                </a-upload>
                <div v-if="bootImageUploadUrl" style="margin-top: 8px">
                  <a-button size="small" @click="removeImage">删除图片</a-button>
                </div>
              </div>

              <!-- 4K 开机图片 -->
              <div>
                <div style="margin-bottom: 4px; font-size: 12px; color: #666">4K(格式jpg，尺寸 3840×2160，大小不超过10M)</div>
                <a-upload
                  name="file"
                  :before-upload="beforeUploadImage4k"
                  :show-upload-list="false"
                  accept=".jpg,.png"
                  list-type="picture-card">
                  <div v-if="!bootImage4kUploadUrl">
                    <a-icon type="plus" />
                    <div style="margin-top: 8px">上传</div>
                  </div>
                  <img v-else :src="bootImage4kUploadUrl.downloadUrl" style="width: 100%; height: 100%; object-fit: cover" />
                </a-upload>
                <div v-if="bootImage4kUploadUrl" style="margin-top: 8px">
                  <a-button size="small" @click="removeImage4k">删除图片</a-button>
                </div>
              </div>

              <!-- <div style="margin-top: 8px; font-size: 12px; color: #999">格式为 jpg，尺寸 1920*1080，大小不超过10M</div> -->
            </div>
          </a-form-item>
        </a-col>

        <a-col :span="12">
          <a-form-item label="开机动画" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-radio-group v-decorator="['bootAnimationType', { initialValue: 0 }]">
              <a-radio :value="0">开机默认</a-radio>
              <a-radio :value="1">自定义</a-radio>
            </a-radio-group>

            <div v-if="form.getFieldValue('bootAnimationType') === 1" style="margin-top: 12px">
              <a-upload name="file" :before-upload="beforeUploadAnimation" :show-upload-list="false" accept=".ts">
                <a-button>
                  <a-icon type="upload" />
                  上传视频
                </a-button>
              </a-upload>
              <div style="margin-top: 8px; font-size: 12px; color: #999">格式为 ts 1920*1080，时长不能超过90s，大小需要超过1KB</div>
              <div v-if="bootAnimationUploadUrl || uploadingAnimation" style="margin-top: 8px">
                <a-progress v-if="uploadingAnimation" :percent="animationUploadProgress.toFixed(2)" status="active" size="small" />
                <a-tag v-else closable @close="removeAnimation">
                  <a-icon type="video-camera" />
                  {{ bootAnimationUploadUrl.name }}
                </a-tag>
              </div>
            </div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="主页应用" v-bind="formItemLayout">
        <a-row :gutter="16">
          <a-col :span="20">
            <a-select
              placeholder="请选择主页应用（选择1个）"
              style="width: 100%"
              :max-count="4"
              v-decorator="['mainAppId']"
            >
              <a-select-option v-for="app in appList" :key="app.id" :value="app.id">
                {{ app.name }}
              </a-select-option>
            </a-select>
            <div v-if="appList.length === 0" style="margin-top: 12px; font-size: 13px; color: #999">
              暂无应用，请前往 <a href="javascript:void(0)" @click="goToResourceManage">资源管理</a> 上传应用
            </div>
          </a-col>
        </a-row>
      </a-form-item>

      <!-- 预装应用 -->
      <a-form-item label="预装应用" v-bind="formItemLayout">
        <a-row :gutter="16">
          <a-col :span="20">
            <a-select
              mode="multiple"
              placeholder="请选择预装应用（最多选择4个）"
              style="width: 100%"
              :max-count="4"
              v-decorator="['appIds', { initialValue: [] }]"
              @change="handleAppSelectChange">
              <a-select-option v-for="app in appList" :key="app.id" :value="app.id">
                {{ app.name }}
              </a-select-option>
            </a-select>

            <div v-if="appList.length === 0" style="margin-top: 12px; font-size: 13px; color: #999">
              暂无应用，请前往 <a href="javascript:void(0)" @click="goToResourceManage">资源管理</a> 上传应用
            </div>
          </a-col>
        </a-row>
      </a-form-item>

      <!-- 菜单配置 -->
      <!-- <a-form-item label="菜单配置" v-bind="formItemLayout">
        <a-radio-group v-decorator="['menuConfigType', { initialValue: 0 }]" :disabled="true">
          <a-radio :value="0">本地上传</a-radio>
          <a-radio :value="1">云端配置</a-radio>
        </a-radio-group>

        <div v-if="form.getFieldValue('menuConfigType') === 0" style="margin-top: 12px">
          <a-upload name="file" :before-upload="beforeUploadMenu" :show-upload-list="false" accept=".zip,.rar">
            <a-button>
              <a-icon type="upload" />
              上传
            </a-button>
          </a-upload>
          <span style="margin-left: 12px; font-size: 12px; color: #999">格式为 zip/rar，文件大小不超过50M</span>
          <div v-if="menuFileName" style="margin-top: 8px">
            <a-tag closable @close="removeMenuFile">
              <a-icon type="file" />
              {{ menuFileName }}
            </a-tag>
          </div>
        </div>
      </a-form-item> -->

      <!-- 定制 - 只在云端配置时显示 -->
      <a-form-item label="定制" v-bind="formItemLayout" v-if="form.getFieldValue('menuConfigType') === 1">
        <a-select placeholder="请选择" style="width: 200px" v-decorator="['customize', { initialValue: 'on' }]">
          <a-select-option value="on">开</a-select-option>
          <a-select-option value="off">关</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 开机设置 - 只在云端配置时显示 -->
      <a-form-item label="开机设置" v-bind="formItemLayout" v-if="form.getFieldValue('menuConfigType') === 1">
        <a-card size="small" :bordered="false" style="background: #fafafa">
          <!-- 系统屏保 -->
          <div style="margin-bottom: 20px">
            <div style="font-weight: 500; margin-bottom: 12px">系统屏保</div>
            <a-radio-group v-decorator="['screenSaverType', { initialValue: 0 }]">
              <a-radio :value="0">默认</a-radio>
              <a-radio :value="1">自定义</a-radio>
            </a-radio-group>
          </div>

          <!-- 其他开机设置 -->
          <div style="margin-bottom: 20px">
            <div style="font-weight: 500; margin-bottom: 12px">XXX设置</div>
            <a-row :gutter="[16, 12]">
              <a-col :span="8">
                <a-form-item label="最大音量" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-input-number
                    :min="0"
                    :max="100"
                    style="width: 100%"
                    v-decorator="['maxVolume', { initialValue: 50 }]" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="调谐锁定" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['tuningLock', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="TV返回主场景" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['tvReturnMain', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="屏蔽WiFi" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['blockWifi', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="屏蔽蓝牙" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['blockBluetooth', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="待机灯状态" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['standbyLight', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <!-- 按键锁定 -->
          <div style="margin-bottom: 20px">
            <div style="font-weight: 500; margin-bottom: 12px">按键锁定</div>
            <a-row :gutter="[20, 12]">
              <a-col :span="8">
                <a-form-item label="本机键锁" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['localKeyLock', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="主机键锁" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['hostKeyLock', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="节目源键锁" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['sourceKeyLock', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="VIP键锁" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['vipKeyLock', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="UMAX键锁" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['umaxKeyLock', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="设置键锁" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['settingKeyLock', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <!-- 功能限制 -->
          <div style="margin-bottom: 20px">
            <div style="font-weight: 500; margin-bottom: 12px">功能限制</div>
            <a-row :gutter="[20, 14]">
              <a-col :span="8">
                <a-form-item label="网络设置许可" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['networkSetting', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="应用安装许可" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['appInstall', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="多屏互动许可" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['multiScreen', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="屏保启动许可" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['screenSaver', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="adb调试开关" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['adbDebug', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="无信号关机" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['noSignalShutdown', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="USB禁用" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
                  <a-select style="width: 100%" v-decorator="['usbDisable', { initialValue: 'off' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <!-- 开机模式 -->
          <div>
            <div style="font-weight: 500; margin-bottom: 12px">开机模式</div>
            <a-row :gutter="[16, 12]">
              <a-col :span="8">
                <a-form-item label="开机模式" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-select style="width: 100%" v-decorator="['bootMode', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="开机音量" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                  <a-input-number
                    :min="0"
                    :max="100"
                    style="width: 100%"
                    v-decorator="['bootVolume', { initialValue: 7 }]" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="开机源" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                  <a-select style="width: 100%" v-decorator="['bootSource', { initialValue: 'hdmi2' }]">
                    <a-select-option value="hdmi1">HDMI 1</a-select-option>
                    <a-select-option value="hdmi2">HDMI 2</a-select-option>
                    <a-select-option value="atv">ATV</a-select-option>
                    <a-select-option value="dtv">DTV</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="ATV开机频道" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <a-input-number :min="1" style="width: 100%" v-decorator="['atvChannel', { initialValue: 1 }]" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="DTV开机频道" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <a-input-number :min="1" style="width: 100%" v-decorator="['dtvChannel', { initialValue: 1 }]" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="开机全屏播放" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <a-select style="width: 100%" v-decorator="['fullScreenPlay', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="开机视频声音" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <a-select style="width: 100%" v-decorator="['bootVideoSound', { initialValue: 'on' }]">
                    <a-select-option value="on">开</a-select-option>
                    <a-select-option value="off">关</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="17">
                <a-form-item label="开机直达应用" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-select style="width: 100%" v-decorator="['bootApp', { initialValue: 'com.changhong.hotelv3' }]">
                    <a-select-option value="com.changhong.hotelv3">com.changhong.hotelv3</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </a-card>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createConfigManage, getAppDropdown, updateConfigManage, uploadFile } from '@/api/configManage'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      uploading: false, // 文件上传状态
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      // 文件相关
      menuFile: null,
      menuFileName: '',
      menuFileUrl: '', // 菜单文件上传后的真实URL
      bootImageFile: null,
      bootImageUrl: '', // 预览用(base64)
      bootImageUploadUrl: '', // 开机图片上传后的真实URL(1080P)
      bootImage4kFile: null,
      bootImage4kUploadUrl: '', // 4K开机图片上传后的真实URL
      bootAnimationUploadUrl: '', // 动画上传后的真实URL
      uploadingAnimation: false, // 视频上传状态
      animationUploadProgress: 0, // 视频上传进度
      // 应用列表
      appList: [],
      isEdit: false,
      currentConfigId: null
    }
  },
  watch: {
    visible (val) {
      if (val) {
        // 监听表单字段变化，重新渲染
        this.$nextTick(() => {
          this.form.setFieldsValue({
            menuConfigType: 0
          })
        })
        this.loadAppList()
      } else {
        this.isEdit = false
      }
    }
  },
  methods: {
    async handleOk () {
      // 检查文件是否正在上传
      console.log(this.uploading)
      if (this.uploading) {
        this.$message.warning('文件正在上传中，请稍后再试')
        return
      }
      this.form.validateFields((err, values) => {
        console.log('values', values, err)
        if (!err) {
          this.confirmLoading = true
          // 上传文件
          this.uploadFiles().then((fileUrls) => {
            // 构建提交数据，包含文件信息
            const submitData = {
              ...values,
              ...fileUrls
            }
            console.log('submitData', submitData)
            if (this.currentConfigId) {
              submitData.id = this.currentConfigId
            }
            console.log('isEdit', this.isEdit, this.currentConfigId)
            if (this.isEdit) {
              updateConfigManage(submitData).then(res => {
                if (res.code === 1) {
                  this.$emit('ok', submitData)
                  this.resetForm()
                  this.confirmLoading = false
                } else {
                  this.$message.error(res.msg || '配置失败')
                  this.confirmLoading = false
                }
                this.handleCancel()
              }).catch(() => {
                this.confirmLoading = false
                this.handleCancel()
              })
            } else {
              createConfigManage(submitData).then(res => {
                if (res.code === 1) {
                  this.$emit('ok', submitData)
                  this.resetForm()
                  this.confirmLoading = false
                } else {
                  this.$message.error(res.msg || '配置失败')
                  this.confirmLoading = false
                }
                this.handleCancel()
              }).catch(() => {
                this.confirmLoading = false
                this.handleCancel()
              })
            }
          }).catch(() => {
            this.confirmLoading = false
            this.handleCancel()
          })
        }
      })
    },

    // 上传文件 - 直接返回已上传的URL（文件在beforeUpload时已上传完成）
    async uploadFiles () {
      const fileUrls = {}
      if (this.menuFileUrl) {
        fileUrls.menuFileUrl = this.menuFileUrl
      }
      if (this.bootImageUploadUrl) {
        fileUrls.bootImage = this.bootImageUploadUrl
      }
      if (this.bootImage4kUploadUrl) {
        fileUrls.bootImage4k = this.bootImage4kUploadUrl
      }
      if (this.bootAnimationUploadUrl) {
        fileUrls.bootAnimation = this.bootAnimationUploadUrl
      }

      return fileUrls
    },
    loadAppList () {
      getAppDropdown().then(res => {
        if (res.code === 1 && res.data) {
          this.appList = res.data || []
        } else {
          this.appList = []
        }
      }).catch(() => {
        this.appList = []
      })
    },

    handleCancel () {
      this.resetForm()
      this.$emit('cancel')
    },

    resetForm () {
      this.form.resetFields()
      this.menuFile = null
      this.menuFileName = ''
      this.menuFileUrl = ''
      this.bootImageFile = null
      this.bootImageUploadUrl = ''
      this.bootImage4kFile = null
      this.bootImage4kUploadUrl = ''
      this.bootAnimationUploadUrl = ''
      this.uploadingAnimation = false
      this.animationUploadProgress = 0
    },

    // 菜单文件上传前校验 - 选择时立即上传
    beforeUploadMenu (file) {
      const isZip = file.name.endsWith('.zip') || file.name.endsWith('.rar')
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isZip) {
        this.$message.error('只能上传 zip 或 rar 文件!')
        return false
      }
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!')
        return false
      }

      // 保存文件信息
      this.menuFile = file
      this.menuFileName = file.name

      // 立即上传文件获取URL
      this.uploadMenuFile(file)

      return false
    },

    // 上传菜单文件
    async uploadMenuFile (file) {
      this.uploading = true
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadFile(formData, 0)
        if (res.code === 1) {
          this.menuFileUrl = res.data
          this.$message.success('菜单文件上传成功')
        } else {
          this.$message.error(res.msg || '菜单文件上传失败')
          this.menuFile = null
          this.menuFileName = ''
        }
      } catch (error) {
        this.$message.error('菜单文件上传失败')
        this.menuFile = null
        this.menuFileName = ''
        console.error('菜单文件上传失败:', error)
      } finally {
        this.uploading = false
      }
    },

    // 图片上传前校验 - 选择时立即上传
    beforeUploadImage (file) {
      const isImage = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isImage) {
        this.$message.error('只能上传 JPG ')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 10MB!')
        return false
      }
      // 保存文件对象
      this.bootImageFile = file

      // 立即上传文件获取真实URL
      this.uploadBootImage(file)

      return false
    },

    // 上传开机图片
    async uploadBootImage (file) {
      this.uploading = true
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadFile(formData, 2)
        if (res.code === 1) {
          this.bootImageUploadUrl = res.data
          this.$message.success('开机图片上传成功')
        } else {
          this.$message.error(res.msg || '开机图片上传失败')
          this.bootImageFile = null
          this.bootImageUploadUrl = ''
        }
      } catch (error) {
        this.$message.error('开机图片上传失败')
        this.bootImageFile = null
        this.bootImageUploadUrl = ''
        console.error('开机图片上传失败:', error)
      } finally {
        this.uploading = false
      }
    },

    // 4K图片上传前校验 - 选择时立即上传
    beforeUploadImage4k (file) {
      const isImage = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isImage) {
        this.$message.error('只能上传 JPG ')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 10MB!')
        return false
      }
      // 保存文件对象
      this.bootImage4kFile = file

      // 立即上传文件获取真实URL
      this.uploadBootImage4k(file)

      return false
    },

    // 上传4K开机图片 (type=4)
    async uploadBootImage4k (file) {
      this.uploading = true
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadFile(formData, 4)
        if (res.code === 1) {
          this.bootImage4kUploadUrl = res.data
          this.$message.success('4K开机图片上传成功')
        } else {
          this.$message.error(res.msg || '4K开机图片上传失败')
          this.bootImage4kFile = null
          this.bootImage4kUploadUrl = ''
        }
      } catch (error) {
        this.$message.error('4K开机图片上传失败')
        this.bootImage4kFile = null
        this.bootImage4kUploadUrl = ''
        console.error('4K开机图片上传失败:', error)
      } finally {
        this.uploading = false
      }
    },

    // 动画上传前校验 - 选择时立即上传
    beforeUploadAnimation (file) {
      const isMP4 = file.name.endsWith('.ts')

      if (!isMP4) {
        this.$message.error('只能上传 ts 文件!')
        return false
      }

      // 立即上传文件获取真实URL
      this.uploadBootAnimation(file)

      return false
    },

    // 上传开机动画
    async uploadBootAnimation (file) {
      this.uploading = true
      this.uploadingAnimation = true
      this.animationUploadProgress = 0

      // 模拟进度
      const progressTimer = setInterval(() => {
        if (this.animationUploadProgress < 90) {
          this.animationUploadProgress += Math.random() * 15
          if (this.animationUploadProgress > 90) {
            this.animationUploadProgress = 90
          }
        }
      }, 200)

      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadFile(formData, 3)
        clearInterval(progressTimer)
        this.animationUploadProgress = 100
        if (res.code === 1) {
          this.bootAnimationUploadUrl = res.data
          this.$message.success('开机动画上传成功')
          setTimeout(() => {
            this.uploadingAnimation = false
          }, 500)
        } else {
          this.$message.error(res.msg || '开机动画上传失败')
          this.bootAnimationUploadUrl = ''
          this.uploadingAnimation = false
        }
      } catch (error) {
        clearInterval(progressTimer)
        this.$message.error('开机动画上传失败')
        this.bootAnimationUploadUrl = ''
        this.uploadingAnimation = false
        console.error('开机动画上传失败:', error)
      } finally {
        this.uploading = false
      }
    },

    // 删除菜单文件
    removeMenuFile () {
      this.menuFile = null
      this.menuFileName = ''
      this.menuFileUrl = ''
    },

    // 删除图片
    removeImage () {
      this.bootImageFile = null
      this.bootImageUploadUrl = ''
    },

    // 删除4K图片
    removeImage4k () {
      this.bootImage4kFile = null
      this.bootImage4kUploadUrl = ''
    },

    // 删除动画
    removeAnimation () {
      this.bootAnimationUploadUrl = ''
      this.uploadingAnimation = false
      this.animationUploadProgress = 0
    },

    // 预装应用选择变化
    handleAppSelectChange (values) {
      console.log(values, 'values')
      if (values.length > 4) {
        this.$message.error('最多只能选择4个应用')
        // 回退到之前的选择
        const currentValues = this.form.getFieldValue('appIds') || []
        this.$nextTick(() => {
          this.form.setFieldsValue({ appIds: currentValues.slice(0, 4) })
        })
      }
    },

    // 跳转到资源管理
    goToResourceManage () {
      this.$emit('goToResourceManage')
    },

    // 加载数据（编辑时使用）
    load (config) {
      if (config) {
        // 设置表单值
        console.log(config, 'config')
        this.isEdit = true
        this.currentConfigId = config.id
        this.form.setFieldsValue({
          name: config.name,
          desc: config.desc || '',
          bootImageType: config.bootImageType !== undefined ? config.bootImageType : 0,
          bootAnimationType: config.bootAnimationType !== undefined ? config.bootAnimationType : 0,
          appIds: config.appIds || [],
          mainAppId: config.mainAppId,
          menuConfigType: config.menuConfigType !== undefined ? config.menuConfigType : 0,
          cloudConfigId: config.cloudConfigId,
          customize: config.customize || 'on',
          screenSaverType: config.screenSaverType || 'default',
          maxVolume: config.maxVolume || 50,
          tuningLock: config.tuningLock || 'on',
          tvReturnMain: config.tvReturnMain || 'on',
          blockWifi: config.blockWifi || 'off',
          blockBluetooth: config.blockBluetooth || 'off',
          standbyLight: config.standbyLight || 'on',
          localKeyLock: config.localKeyLock || 'off',
          hostKeyLock: config.hostKeyLock || 'off',
          sourceKeyLock: config.sourceKeyLock || 'off',
          vipKeyLock: config.vipKeyLock || 'off',
          umaxKeyLock: config.umaxKeyLock || 'off',
          settingKeyLock: config.settingKeyLock || 'off',
          networkSetting: config.networkSetting || 'on',
          appInstall: config.appInstall || 'on',
          multiScreen: config.multiScreen || 'on',
          screenSaver: config.screenSaver || 'on',
          adbDebug: config.adbDebug || 'off',
          noSignalShutdown: config.noSignalShutdown || 'off',
          usbDisable: config.usbDisable || 'off',
          bootMode: config.bootMode || 'on',
          bootVolume: config.bootVolume || 7,
          bootSource: config.bootSource || 'hdmi2',
          atvChannel: config.atvChannel || 1,
          dtvChannel: config.dtvChannel || 1,
          fullScreenPlay: config.fullScreenPlay || 'on',
          bootVideoSound: config.bootVideoSound || 'on',
          bootApp: config.bootApp || 'com.changhong.hotelv3'
        })

        // 设置文件信息
        if (config.menuFileName) {
          this.menuFileName = config.menuFileName
        }
        if (config.bootImage) {
          this.bootImageUploadUrl = config.bootImage
        }
        if (config.bootImage4k) {
          this.bootImage4kUploadUrl = config.bootImage4k
        }
        if (config.bootAnimation) {
          this.bootAnimationUploadUrl = config.bootAnimation
        }
      }
    }
  }
}
</script>

<style scoped>
/* 移除大部分自定义样式，使用Ant Design原生样式 */
.ant-upload-select-picture-card {
  width: 104px;
  height: 104px;
}

/* 保留必要的卡片背景色 */
.ant-card-bordered {
  border: none;
}
</style>

<style>
/* 文件上传时确定按钮置灰样式（非scoped） */
.config-modal-uploading .ant-modal-confirm-btns .ant-btn-primary {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
